
import React, { useState, useEffect } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const Accordion = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={() => setIsOpen(!isOpen)}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

function Quote_Hjf843pqCs905gn() {
    const navigate = useNavigate();
    const [input, setInput] = React.useState('');
    const [unlocked, setUnlocked] = React.useState(false);
    const [error, setError] = React.useState('');
    const [suppressNotifications, setSuppressNotifications] = useState('');

    const [quoteData, setQuoteData] = React.useState(null);

    useEffect(() => {
        fetch('/api/quoteRoute/Hjf843pqCs905gn')
            .then(r => r.json())
            .then(setQuoteData);
    }, []);

    const unlock = (suppressNotification = false, meta = {}) => {
        setUnlocked(true);
        setSuppressNotifications(suppressNotification);

        if (suppressNotification) return;

        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: 'Hjf843pqCs905gn',
                unlockMethod: meta.method,
                unlockValue: meta.value
            })
        }).catch(() => { });
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your access code"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                const validCodes = [
                                    quoteData?.clientPhone,
                                    quoteData?.clientPhone2,
                                    quoteData?.customPassword,
                                ].filter(Boolean).map(c => c.replace(/\D/g, '') || c.trim());

                                if (cleaned === '1131') {
                                    unlock(true);
                                } else if (validCodes.includes(cleaned)) {
                                    unlock();
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            const validCodes = [
                                quoteData?.clientPhone,
                                quoteData?.clientPhone2,
                                quoteData?.customPassword,
                            ].filter(Boolean).map(c => c.replace(/\D/g, '') || c.trim());

                            if (cleaned === '1131') {
                                unlock(true);
                            } else if (validCodes.includes(cleaned)) {
                                unlock();
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
                            <p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
                            <p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>


                        <div className="quote-section">
                            <div className='quote-subsection'>
                                <div className="project-description">
                                    This project involves the structural modification of the exterior walls to install three new exterior windows into the existing 8x8x16 CMU walls. Two standard double-hung windows will be added to provide natural light and ventilation, while a third smaller frosted double-hung will potentially be installed in the bathroom. To minimize structural impact and dust, windows will be sized to "whole-block" increments, ensuring a clean fit within the existing masonry grid.
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Scope of work</h3>
                                <div className="white-card">
                                    <ul className="scope-list">
                                        <li><strong>Site Prep & Dust Mitigation:</strong> Reroute surface-mounted EMT conduit. Establish heavy-duty poly-sheeting barriers to contain masonry dust and slurry during the cutting phase.</li>
                                        <li><strong>Structural Shoring:</strong> Install temporary 4x4 vertical supports and head-plates to support roof rafters on load-bearing spans while the block is being removed.</li>
                                        <li><strong>Precision Masonry Cutting:</strong> Use a 14" diamond-blade saw to cut openings aligned with existing mortar joints. This ensures a clean, factory-finish look and minimizes structural vibration.</li>
                                        <li><strong>Lintel Installation:</strong> Set pre-cast concrete lintels into mortar beds above the two larger openings, with minimum 8" bearing on each side to ensure full-depth support of the 8" masonry wall.</li>
                                        <li><strong>Buck Installation:</strong> Install 2x pressure-treated wood bucks using Tapcon masonry fasteners. Shim plumb and level; foam entire perimeter on both interior and exterior faces.</li>
                                        <li><strong>Window Installation:</strong> Set, level, and plumb three windows. Fasten through frames into the PT bucks.</li>
                                        <li><strong>Waterproofing & Finish:</strong> Apply professional-grade polyurethane sealant to all exterior junctions. Use low-expansion foam for interior air-sealing and patch chipped block with Type S mortar.</li>
                                        <li><strong>Debris Removal:</strong> Haul away all concrete block debris and masonry waste for proper disposal.</li>
                                    </ul>
                                    <div className="time-expectation"><strong>Time expectation:</strong> 5 days (32-36 hours)</div>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Sizing Strategy</h3>
                                <div className="white-card">
                                    <div className="white-card-comment">
                                        To keep labor costs down and the installation clean, I have planned these openings for <strong>32" and 40" widths</strong>. This prevents the need for hundreds of small vertical cuts and maintains the highest possible structural integrity of the surrounding wall.
                                    </div>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label" style={{ backgroundColor: '#fff3cd', padding: '0.5rem', borderRadius: '4px' }}>Material Standards & Structural Adjustments</h3>
                                <div className="white-card">
                                    <p>
                                        To ensure this installation meets Florida Building Code and maintains the structural integrity of your home, I have finalized the material list with the following professional standards. I do my best to be as up-front and transparent as possible regarding pricing, but sometimes the initial "ballpark" estimate requires adjustment once the final engineering and logistics are settled. You'll notice an increase from our initial conversation, driven primarily by these specific requirements:
                                    </p>
                                    <ul className="material-card-list">
                                        <li><strong>Safety & Code Compliance:</strong> The bathroom window requires <strong>tempered safety glass</strong> and Florida-approved framing. These are required by code for wet areas/showers to prevent injury and ensure wind-load compliance.</li>
                                        <li><strong>Structural Lintels:</strong> For an 8-inch block wall, a full-depth <strong>8x8 pre-cast concrete beam</strong> is required for every opening. This provides 100% support for the masonry above, preventing the interior cracks that occur with cheaper, narrow steel angles.</li>
                                        <li><strong>Electrical Infrastructure:</strong> The electrical reroute requires specific 12ga THHN conductors and EMT conduit to safely clear the new openings while maintaining garage circuit integrity.</li>
                                        <li><strong>Dust Containment:</strong> I have included a comprehensive 6-mil poly-sheeting system to isolate the work area. Masonry cutting is a messy process, and this protects your belongings from fine concrete dust.</li>
                                    </ul>
                                    <p style={{ marginTop: '1rem', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
                                        <strong>My Promise:</strong> While material costs fluctuate based on supplier pricing, <strong>my labor rate is flat and locked in.</strong> I bill materials at my exact cost with zero markup, and I will provide you with every original receipt for your records.
                                    </p>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Itemized Materials (At Cost)</h3>
                                <div className="white-card">
                                    <ul className="material-card-list">
                                        <li><strong>Structural Lintels (3):</strong> $320</li>
                                        <li><strong>Bedroom Windows (2):</strong> $558</li>
                                        <li><strong>Bathroom Window (Tempered):</strong> $324</li>
                                        <li><strong>Masonry Saw & Diamond Blade:</strong> $190</li>
                                        <li><strong>PT Lumber, Shoring & Fasteners:</strong> $168</li>
                                        <li><strong>Sealants & Weatherproofing:</strong> $211</li>
                                        <li><strong>Electrical Reroute Supplies:</strong> $156</li>
                                        <li><strong>Misc Masonry & Site Safety:</strong> $225</li>
                                        <li><strong>Sales Tax:</strong> $147</li>
                                        <li><strong>Procurement & Delivery:</strong> $50</li>
                                    </ul>
                                    <div className="material-note" style={{ marginTop: '1rem', borderTop: '1px solid #eee', paddingTop: '0.5rem' }}>
                                        <strong>Transparency Guarantee:</strong> All materials are billed at my exact contractor cost with zero markup. Copies of all original receipts will be provided for your records.
                                    </div>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Final Pricing</h3>
                                <div className="quote-pricing-block">
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate / locked):</span>
                                        <span className="pricing-value">$2,600</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials (estimated at cost):</span>
                                        <span className="pricing-value">$2,350</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Total Estimated Project Cost:</span>
                                        <span className="pricing-value">$4,950</span>
                                    </div>
                                </div>
                                <div className="pricing-note">The material deposit of <strong>$2,350</strong> is required to order the windows and schedule the start date.
                                </div>
                            </div>

                        </div>

                        <hr style={{ marginTop: '3rem' }} />
                        <h2>Next Steps</h2>
                        <p>
                            Estimates provided are valid for 30 days. For any project that requires a material order above $500, a deposit covering material costs is required prior to scheduling. Labor is due upon completion of the work.
                        </p>
                        <p>
                            <strong>Please reach out</strong> whenever you are ready to move forward or if you have any questions!
                        </p>
                    </div>
                </section>
            </main>
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img
                        src="/transparent-logo-min.png"
                        alt="North Florida Home Repair & Maintenance"
                        className="footer-logo"
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>

                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div>
    );
}

export default Quote_Hjf843pqCs905gn;
